const { save } = require('./save')
exports.save = save
